import { createAction } from "@reduxjs/toolkit";

export const updateHasAnyRAChange = createAction<boolean>(
  "[RiskAnalysisProcess] Update Has Any Change"
);
export const updateSaveAndCompleteRiskAnalysis = createAction<boolean>(
  "[RiskAnalysisProcess] Update Save And Complete Risk Analysis"
);
export const setIsSubmittedRiskAnalysis = createAction<boolean>(
  "[RiskAnalysisProcess] Update Is Submitted RiskAnalysis"
);
